import { configureStore } from "@reduxjs/toolkit";
import merchantHeatmapReducer from "../features/MERCHANT/merchant-heatmap/MerchantHeatmap.slice";
import merchantLiveEventsMapReducer from "../features/MERCHANT/merchant-heatmap/MerchantLiveEventsMap.slice";
import merchantRewardHistoryReducer from "../features/MERCHANT/merchant-reward-history/MerchantRewardHistory.slice";

const reducer = {
    merchantHeatmap: merchantHeatmapReducer,
    merchantLiveEventsMap: merchantLiveEventsMapReducer,
    merchantRewardHistory: merchantRewardHistoryReducer,
};

export const createAppStore = () => configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const store = createAppStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof createAppStore>;
